import styled from "styled-components";
import { palette, size } from "styled-theme";

const Wrapper = styled.div`
.verification{
    padding: 10px 0 10px;
}
.verification p {
    display: flex;
    padding-left: 3px;
    padding-bottom: 7px;
    color: ${palette("formInputElement", 0)};
    font-weight: 400;
    font-size: ${size("p1")};
    
}

.verification .validation-message{
    top: auto;
}

input:focus-within {
  outline: 1px dotted #212121;
  outline: 5px auto -webkit-focus-ring-color;
}

.verification-options{
    display: flex;
    padding-left: 3px;
    color: ${palette("formInputElement", 0)};
    font-weight: 400;
    font-size: ${size("p2")};
    justify-content: flex-start;
    align-items: center;
}
.verification-options input{
    margin-right: 10px;
}
.option-container{
    margin-right:30px;
}
`;

export default Wrapper;
